<template>
  <v-sheet>
    <headline-bar>
      <template v-slot:prepend-btn>
        <v-btn icon @click.stop="dismissSideSheet">
          <v-icon>{{
            sideSheetIsOn && $vuetify.breakpoint.xs ? icons.back : icons.close
          }}</v-icon>
        </v-btn>
      </template>

      Personal info
    </headline-bar>

    <div class="pa-6 flex-grow-1">
      <!-- Name -->
      <v-text-field v-model="user.firstName" label="First name" placeholder="" filled color="secondary"></v-text-field>
      <v-text-field v-model="user.lastName" label="Last name" placeholder="" filled color="secondary"></v-text-field>

      <!-- GENDER DROPDOWN -->
      <v-select v-model="user.gender" :menu-props="{ offsetY: true }" :items="genders" label="Gender" filled color="secondary"></v-select>

      <!-- DATE OF BIRTH -->
      <v-menu v-model="dateMenu" :close-on-content-click="false" transition="scale-transition" min-width="auto">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="user.dateOfBirth"
            v-bind="attrs"
            v-on="on"
            label="Date of Birth"
            placeholder=""
            append-icon="mdi-calendar"
            @click:append="dateMenu = !dateMenu"
            filled
            readonly
            color="secondary"
          ></v-text-field>
        </template>

        <v-date-picker v-model="user.dateOfBirth" @input="dateMenu = false" color="secondary" class="pb-3"></v-date-picker>
      </v-menu>

      <!-- COUNTRY OF BIRTH -->
      <v-autocomplete
        v-model="user.countryOfBirth.info"
        :items="countries"
        return-object
        item-text="name"
        item-value="code"
        @contextmenu.native="disableContextMenu"
        label="Country of birth"
        placeholder="Select ..."
        no-data-text="Not available"
        required
        filled
        color="secondary"
      >
        <template v-slot:item="data">
          <!-- <v-list-item-avatar size="32">
            <v-icon class="flag-border" size="24"> ${{ data.item.flag }} </v-icon>
          </v-list-item-avatar> -->
          <v-list-item-content>
            <v-list-item-title> {{ data.item.name }} </v-list-item-title>
          </v-list-item-content>
        </template>
      </v-autocomplete>

      <!-- NATIONALITY -->
      <v-autocomplete
        v-model="user.nationality.info"
        :items="countries"
        return-object
        item-text="name"
        item-value="code"
        @contextmenu.native="disableContextMenu"
        label="Nationality"
        placeholder="Select ..."
        no-data-text="Not available"
        required
        filled
        color="secondary"
      >
        <template v-slot:item="data">
          <!-- <v-list-item-avatar size="32">
            <v-icon class="flag-border" size="24"> ${{ data.item.flag }} </v-icon>
          </v-list-item-avatar> -->
          <v-list-item-content>
            <v-list-item-title> {{ data.item.name }} </v-list-item-title>
          </v-list-item-content>
        </template>
      </v-autocomplete>

      <!-- SUBMIT BTN -->
      <v-btn :light="$vuetify.theme.dark" :dark="!$vuetify.theme.dark" class="float-right" @click="personalChange">
        Submit
      </v-btn>
    </div>
  </v-sheet>
</template>

<script>
export default {
  data() {
    return {
      user: {
        firstName: "",
        lastName: "",
        gender: "",
        dateOfBirth: "",
        countryOfBirth: "",
        nationality: ""
      },

      date: new Date().toISOString().substr(0, 10),
      time: "16:20:00",
      dateMenu: false
    }
  },

  computed: {
    sideSheetIsOn() {
      return this.$store.getters["SideSheet/isOn"]
    },

    countries() {
      return this.$store.getters["Countries/countries"]
    },

    genders() {
      return this.$store.getters["Misc/genders"]
    },

    personalInfo() {
      return this.$store.getters["Profile/personalInfo"]
    }
  },

  methods: {
    dismissSideSheet() {
      this.$store.dispatch("SideSheet/toggleSideSheet", { isOn: false })
    },

    personalChange() {
        // console.log(this.user.countryOfBirth)
      this.$store.dispatch("Profile/personalChange", { user: this.user })
      this.dismissSideSheet()
    }
  },

  mounted() {
    this.sideSheet = this.sideSheetIsOn
    // console.log(this.user)
  },

  created() {
   this.user.firstName = this.personalInfo.firstName.value
   this.user.lastName = this.personalInfo.lastName.value
   this.user.gender = this.personalInfo.gender.value
   this.user.dateOfBirth = this.personalInfo.dateOfBirth.value
  //  console.log(this.user.dateOfBirth.value)
   this.user.countryOfBirth = this.personalInfo.countryOfBirth
   this.user.nationality = this.personalInfo.nationality
  }
}
</script>

<style lang="sass" scoped>

.gender-box
    border: 1px solid rgba(#111111, 0.1)
    border-radius: 8px

.flag-border
    border: 1px solid rgba(#111111, 0.1)
    border-style: outset
</style>
